export default {
  data() {
    return {
      domain: this.$route.params.projectCode
    };
  },
  props: {
    name: {}
  },
  computed: {
    exam_type: {
      get() {
        return this.$store.state.examInfo.currentExamInfo.exam_type;
      }
    },
    excuse_exam: {
      get() {
        return parseInt(
          this.$store.state.examInfo.currentExamInfo.exempt_exam_is_open
        );
      }
    },
    invoice_type: {
      get() {
        return parseInt(
          this.$store.state.examInfo.currentExamInfo.invoice_is_open
        );
      }
    },
    isHideGrade: {
      get() {
        if (this.$store.state.examInfo.currentExamInfo.function_module) {
          return this.$store.state.examInfo.currentExamInfo.function_module.filter(item => {
            return item.module_type == "results_release_module";
          })[0].selected;
        } else {
          return 0;
        }
      }
    },
    isHideCertificate: {
      get() {
        if (this.$store.state.examInfo.currentExamInfo.function_module) {
          return this.$store.state.examInfo.currentExamInfo.function_module.filter(
            item => {
              return item.module_type == "certificate_module";
            }
          )[0].selected;
        } else {
          return 0;
        }
      }
    },
  },
  created() { },
  methods: {
    onQuit: function () {
      this.$store.commit("removeCurrentUser");
      this.$router.go(0);
      window.location.reload();
    }
  }
};